/**
 * Welchen Tag der Spiegel des Tages beschreibt. (17.09.2026)
 *
 * ## Warum das in `shared/` steht und nicht im Server
 *
 * Diese eine Regel — „der Spiegel beschreibt den VORTAG" — lag am 16.09. in
 * DREI Kopien im Server. Ich habe sie damals zu `spiegelStandardTag()`
 * zusammengezogen und dazugeschrieben: *„drei Kopien einer Regel sind drei
 * Gelegenheiten, sie auseinanderlaufen zu lassen."*
 *
 * Am 17.09. meldete Martin: *„Bei Spiegel des Tages steht, wenn ich auf Musik
 * anspielen klicke, dass es noch keinen Spiegel gibt und daher keiner erzeugt
 * werden konnte. Das verstehe ich nicht."*
 *
 * Es gab zwei weitere Kopien, die ich übersehen hatte — beide mit `sv-SE`
 * statt `en-CA` geschrieben, weshalb meine Suche sie nicht fand:
 *
 *   server/essence-mirror.ts:798   die Musik rechnete HEUTE aus
 *   frontend/app.ts:7075           der Klang-Kasten ebenso
 *
 * Seit der Nachtlauf den Vortag schreibt, suchten beide an einem Tag, an dem
 * nichts steht — daher „es gibt noch keinen Spiegel".
 *
 * ⚠️ Die Regel gehört deshalb dorthin, wo BEIDE Seiten sie lesen können.
 *    Solange sie im Server lag, musste das Frontend sie nachbauen — und eine
 *    nachgebaute Regel ist eine Kopie, egal wie sorgfältig sie entsteht.
 */

/**
 * Der Tag, den ein frisch erzeugter Spiegel beschreibt: GESTERN, in Wiener
 * Zeit.
 *
 * ⚠️ `en-CA` liefert YYYY-MM-DD. `sv-SE` täte dasselbe — genau diese zwei
 *    Schreibweisen nebeneinander haben die Kopien so lange verborgen. Hier
 *    gibt es nur noch eine.
 */
export function spiegelStandardTag(jetzt: Date = new Date()): string {
  return new Date(jetzt.getTime() - 86_400_000).toLocaleDateString("en-CA", {
    timeZone: "Europe/Vienna",
  });
}
